import './payment-provider';
import { createRoot } from 'react-dom/client';
import App from './App';
import './shell.css';
import './mobile-safe-area.css';

// The migrated UI still uses imperative legacy scripts (app.js/call.js/drone.js).
// Avoid React StrictMode's development-only double effect execution so those
// scripts and their event listeners are initialized exactly once.
createRoot(document.getElementById('root')!).render(<App />);
